export const transitionDefault = '250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms';
